import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes, { func } from "prop-types";
import Box from "@mui/material/Box";
import { Autocomplete, TextField, createFilterOptions } from "@mui/material";
import ClipLoader from "react-spinners/ClipLoader";
import axios from "axios";
import { useDebounce } from "use-debounce";
import {
  RequiredFieldDivError,
  TextInputLabelRequired,
} from "./SupplierItems.styled";
import {
  autoSearchInputStylesError,
  autoSearchInputStyles,
} from "@utils/extra-style";

const HaulierCompany = (props) => {
  const {
    t,
    item,
    itemIndex,
    isEditMode,
    objectType,
    onChange,
    platformCountryId,
  } = props;

  const [selectedCompany, setSelectedCompany] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [isCompanySuggestionsLoading, setCompanySuggestionsLoading] =
    useState(false);
  useEffect(() => {
    if (selectedCompany?.id) onChange(selectedCompany, itemIndex, "company");
  }, [selectedCompany]);
  const countryId = platformCountryId;

  const [query, setQuery] = useState();
  const [debounceQuery] = useDebounce(query, 700);

  useEffect(() => {
    if (isEditMode) {
      let entityGroupList = [];
      if (item?.company?.value?.id) {
        entityGroupList.push({
          name: item?.company?.value?.name,
          id: item?.company?.value?.id,
        });
      }
      if (selectedCompany === null) setSelectedCompany([]);
      if (selectedCompany?.length === 0) setSelectedCompany(entityGroupList[0]);
    } else if (!isEditMode) {
      const url = `/general/search?search=&limit=50&orderBy=asc&orderColumn=name&countries=[${countryId}]&objectTypes=["${objectType}"]`;
      getEntityData(url, "selectedDefault");
    }
  }, [objectType]);

  const handleChange = (e) => {
    setQuery(e.target.value || undefined);
  };

  useEffect(() => {
    searchEntity();
  }, [debounceQuery]);

  const searchEntity = () => {
    const search = query;
    if (search) {
      let url = `/general/search?search=${search}&limit=50&orderBy=asc&orderColumn=name&countries=[${countryId}]&objectTypes=["${objectType}"]`;
      getEntityData(url, "all");
    }
  };
  const getEntityData = (url, type) => {
    setCompanySuggestionsLoading(true);
    axios
      .get(url)
      .then((response) => {
        let entityGroupList = [];
        if (response?.data?.companies) {
          response.data.companies.map((key) => {
            entityGroupList.push({
              name: "#" + key.id + " - " + key.name,
              id: key.id,
            });
          });
          setCompanyList(entityGroupList);
          setCompanySuggestionsLoading(false);
          if (
            type === "selectedDefault" &&
            response.data.companies.length === 1
          ) {
            setSelectedCompany(entityGroupList[0]);
          }
        }
      })
      .catch((error) => {
        if (window.debugMode) {
          console.error(
            "Error: an error occurred while fetching entities",
            error
          );
        }
        setCompanyList([]);
        setCompanySuggestionsLoading(false);
      });
  };

  return (
    <div>
      <TextInputLabelRequired error={item.company.error}>
        {t("SUPPLIERS_PLANNING_FORM_HAULIER")}
        {isCompanySuggestionsLoading && (
          <ClipLoader size={15} background="#15aee5 !important" />
        )}
      </TextInputLabelRequired>

      <Autocomplete
        id="tags-outlined"
        options={companyList}
        getOptionLabel={(option) => option.name || " "}
        style={{ zIndex: 99 }}
        filterSelectedOptions
        onKeyUp={handleChange}
        // renderInput={(params) => <TextField {...params} placeholder="" />}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder=""
            size="small"
            style={
              item.company.error !== ""
                ? autoSearchInputStylesError
                : autoSearchInputStyles
            }
          />
        )}
        value={selectedCompany}
        onChange={(event, newValue) => {
          setSelectedCompany(newValue);
        }}
        renderOption={(props, option) => (
          <Box component="li" {...props} key={option.id}>
            {option.name}
          </Box>
        )}
        // renderValue={(value, getItemProps) => (
        //   <Chip label={value} {...getItemProps()} />
        // )}
        // Add These props
        isOptionEqualToValue={(option, value) => option.id === value.id}
        filterOptions={(options, params) => {
          const filtered = createFilterOptions()(options, params);
          return [...filtered];
        }}
      />
      {item.company.error !== "" && (
        <RequiredFieldDivError>{item.company.error}</RequiredFieldDivError>
      )}
    </div>
  );
};

HaulierCompany.propTypes = {
  t: PropTypes.func.isRequired,
  isEditMode: PropTypes.bool,
  objectType: PropTypes.string.isRequired,
  queryParamType: PropTypes.number,
  isEditable: PropTypes.bool,
  leadId: PropTypes.number,
  platformCountryId: PropTypes.number,
};

HaulierCompany.defaultProps = {
  isEditMode: false,
  platformCountryId: null,
};
export default withTranslation()(HaulierCompany);
